export const fetchSuggestions = (query) =>
  `https://socoins-d3843d3c894b.herokuapp.com/coins/search/${query}`;

export const fetchCryptoSuggestions = (query) =>
  `https://api.coinranking.com/v2/search-suggestions?query=${query}`; //CORS (à supprimer celui du dessus et intégrer dans coinRankingApi)